import { EventTypes, TYPES } from '../../render/constants';

// Apply style brush to target node(s)
export function styleBrushAction(hitTestContext) {
  const { type, provider, stageContext, targetNode, targetRegion } = hitTestContext;
  const interactive = provider;
  if (!interactive || !interactive.brush) return false;
  interactive.cursor.set('brush');

  // Support both legacy object and structured { style, mode }
  if (type === EventTypes.down) {
    const brushPayload = interactive.brush;
    const styleData = brushPayload.style || brushPayload;
    const mode = brushPayload.mode || 'text';

    if (mode === 'text' && targetNode && targetNode.type !== TYPES.text) {
      interactive.brush = null;
      return false;
    }

    const nodesToApply = [];
    if (targetNode) {
      nodesToApply.push(targetNode);
    } else if (targetRegion && Array.isArray(targetRegion.nodes) && targetRegion.nodes.length) {
      nodesToApply.push(...targetRegion.nodes);
    }
    if (nodesToApply.length === 0) return false;

    const textKeys = [
      'fill',
      'strokes',
      'background',
      'borderColor',
      'borderWidth',
      'fontFamily',
      'fontSize',
      'fontWeight',
      'fontStyle',
      'textAlign',
      'letterSpacing',
      'lineHeight',
      'effect',
      'shadow',
    ];
    const generalKeys = [
      'fill',
      'stroke',
      'strokeWidth',
      'background',
      'effect',
      'shadow',
      'opacity',
      'cornerRadius',
    ];

    nodesToApply.forEach((node) => {
      if (mode === 'text' && node.type !== TYPES.text) return;
      const keys = mode === 'text' ? textKeys : generalKeys;
      const patch = {};
      keys.forEach((k) => {
        if (styleData[k] !== undefined) patch[k] = styleData[k];
      });
      if (Object.keys(patch).length) {
        stageContext.api.updateNode(node.id, patch);
      }
    });
  } else if (type === EventTypes.up) {
    return false;
  }

  // consume event to avoid moving/selecting on brush click
  return true;
}
